import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

export default function HomePageLink () {
  return (
    <Link className='home-link' to="/">CCA MFA 2021</Link>

  )
}
